import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-background-900 text-background-200 pt-14 md:pt-16 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-base font-bold">黑</span>
              <span className="text-lg font-heading font-bold text-background-50">黑料官网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">{footerData.description}</p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerData.quickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(link.href);
                  }}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500">优质内容平台持续接入中，敬请期待。</p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center text-background-400 hover:text-primary-400 bg-background-800 rounded-lg transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center text-background-400 hover:text-primary-400 bg-background-800 rounded-lg transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center text-background-400 hover:text-primary-400 bg-background-800 rounded-lg transition-colors">
                <i className="ri-telegram-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黑料官网. 本站仅提供导航服务，不存储任何内容。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}